import { TFunction } from 'i18next';
import { enqueueSnackbar } from 'notistack';

export const handleError = (
  error: any,
  t?: TFunction<'translation', undefined>,
) => {
  try {
    const messages = error?.response?.data?.message || error?.message;
    const isArray = Array.isArray(messages);
    if (isArray) {
      for (let message of messages) {
        enqueueSnackbar &&
          enqueueSnackbar(t ? t(`error.${message}`) : message, {
            variant: 'error',
          });
      }
    } else {
      enqueueSnackbar &&
        enqueueSnackbar(t ? t(`error.${messages}`) : messages, {
          variant: 'error',
        });
    }
  } catch (e) {
    console.error(e);
  }
};
